import { useContainer } from '../../useContainer';
import { ClientApi } from '../../../api';
import { PostTermsDto } from '../../../commonTypes/client.types';
import { AppError } from '../../../api/utils/ErrorHandler';

interface ExecPostOptions {
    onSuccess?: () => void;
    onError?: (error: AppError | string) => void;
}

const useHttpPostPaymentTerms = () => {
    const clientApi: ClientApi = useContainer(ClientApi);

    const execPost = (terms: PostTermsDto[], options?: ExecPostOptions) => {
        const { exec, abort } = clientApi.postTerms({
            body: terms,
            onSuccess: () => {
                options?.onSuccess?.();
            },
            onError: (error: AppError | string) => {
                options?.onError?.(error);
            },
        });
        exec();
        return abort;
    };

    return { execPost };
};

export default useHttpPostPaymentTerms;
